import React, { useEffect, useState } from "react";
import style from "../../DetailContainer.module.scss";
import styles from "../../../Kanban/CandidateCard.module.scss";
import { GrDocumentText } from "react-icons/gr";
import {
  dateFormate,
  dateFormateDD,
  decryptedAdminID,
  getMainStageBadge,
  getSu,
  getSubStageBadge,
} from "../../../../utility";
import { BsPencilSquare, BsThreeDotsVertical } from "react-icons/bs";
import { Autocomplete, MenuItem, Popover, TextField } from "@mui/material";
import { getAdminIds } from "../../../../services/candidateServices";
import { AiOutlineClose } from "react-icons/ai";
import { MyModal } from "../../../Common/Model/MyModal";
import ModalContainer from "../../../Common/Model/ModalContainer";
import { updateInterviewAdminID, updateInterviewStatus } from "../../../../services/interviewServices";
import { useDispatch, useSelector } from "react-redux";
import SuccessTick from "../../../success_tick";
import {
  UpdatejoiningCtc,
  UpdatejoiningDayPipelineStatus,
} from "../../../../apiServices";
import { fetchPipeline } from "../../../../redux-store/slices/pipelineSlice";

function Interviews({ data = [], reloadInterviews }) {
  const { filters } = useSelector((state) => state.pipeline);
  const [anchorEl, setAnchorEl] = useState(null);
 const today = new Date().toISOString().split("T")[0];
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  const [assignOpen, setAssignOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedInterviewId, setSelectedInterviewId] = useState(null);
  const [currentAdminId, setCurrentAdminId] = useState(null);
  const [showCtcEdit, setShowCtctEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableSubmit, setenableSubmit] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [joinedId, setjoinedId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [showerrMsg, setShowerrMsg] = useState(false);
  const [Interviewmessage, setInterviewmessage] = useState("");
  const adminID = decryptedAdminID();
  const dispatch =useDispatch();
  const [status, setStatus] = useState({
  eventDate: "",
  notes: ""
});

const [errors, setErrors] = useState({
  eventDate: ""
});
  
  const open = Boolean(anchorEl);
  useEffect(() => {
    console.log(data);
  }, [data]);

  const handleMenuClick = (event, id, adminId , doc) => {
    console.log(doc,"docdoc");
    
    setAnchorEl(event.currentTarget);
    setSelectedInterviewId(id);
    setCurrentAdminId(adminId); // ✅ store current admin
    setSelectedCandidate(doc);
  };
  const hasJoinedCtc = data && Array.isArray(data) && data.some(doc => Number(doc.current_stage_id) === 27);

  const [interviewStatus, setInterviewStatus] = useState({
    caninterviewid: "",
    statusfield: "",
    date: null,
    notes: [],
    replaceCandidate: "",
    ctc: "",
  });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchAdmins = async () => {
    try {
      const res = await getAdminIds({
        id: decryptedAdminID(),
        onlyMe: false,
      });

      // ✅ ensure array
      const list = Array.isArray(res) ? res : res?.data || res?.result || [];

      setAdminList(list);
    } catch (err) {
      console.error(err);
      setAdminList([]); // fallback
    }
  };

  const handleAdminChange = (_, value) => {
    console.log(value, "assignTo id");

    setSelectedAdmin(value);
  };
  const handleAssign = async () => {
    if (!selectedAdmin) {
      alert("Select admin");
      return;
    }

    if (!selectedInterviewId) {
      alert("No interview selected");
      return;
    }

    try {
      setLoading(true);

      await updateInterviewAdminID({
        id: selectedInterviewId,
        admin_id: selectedAdmin.admin_id,
      });
      setOpenSuccess(true);
      setAssignOpen(false);
      setSelectedAdmin(null);
      setSelectedInterviewId(null);
      setTimeout(() => setOpenSuccess(false), 2000);
      reloadInterviews && reloadInterviews();
    } catch (err) {
      console.error(err);
      alert("Assign failed");
    } finally {
      setLoading(false);
    }
  };

  const submitCtc = async (e) => {
    e.preventDefault();
    setenableSubmit(true);

    let obj = {
      id: joinedId,
      ctc: interviewStatus.ctc,
    };

    setShowSuccess(true);

    try {
      const response = await UpdatejoiningCtc(obj);
      console.log(response, "response");

      // if (reloadInterviews) {
      //   await reloadInterviews();
      // }

      setTimeout(() => {
        setenableSubmit(false);
        setShowSuccess(false);
        setShowCtctEdit(false);
      }, 2000);
      reloadInterviews && reloadInterviews();
    } catch (error) {
      console.error("Error updating CTC:", error);
      alert("Failed to update CTC. Please try again.");
      setenableSubmit(false);
      setShowSuccess(false);
    }
  };
const handleChange = (e) => {
  const { name, value } = e.target;
  setStatus((prev) => ({
    ...prev,
    [name]: value
  }));
};

const toInt = (val) => (val ? Number(val) : null);
    const handleSubmit = async () => {
      let newErrors = {
        eventDate: "",
      };
  let isValid = true;

  if (!status.eventDate) {
    newErrors.eventDate = "Date is required";
    isValid = false;
  }

  setErrors(newErrors);
  if (!isValid) return;

  
      const payload = {
        interview_id: selectedCandidate?.id,
        from_stage_id: toInt(selectedCandidate?.current_stage_id),
        from_sub_stage_id: toInt(selectedCandidate?.current_sub_stage_id),
        to_stage_id: 8,
        to_sub_stage_id: 12,
        moved_by: toInt(adminID),
        reason_id:  null,
        custom_reason:  null,
        notes: status.notes || null,
        event_date: dateFormate(status.eventDate).trim(),
      };
  
      setLoading(true);
      try {
        const res = await updateInterviewStatus(payload);
        // console.log(payload);
      
        // ❗ handle API-level failure
        if (!res?.success) {
          setShowerrMsg(true);
          setInterviewmessage(res?.message || "Something went wrong!");
          return;
        }
  
        setSuccess(true);
  
  
        setTimeout(async () => {
          setOpenModal(false);
         reloadInterviews && reloadInterviews();
                 await dispatch(fetchPipeline({
                 ...filters,
                 offset: 0
                 }));
  
          setSuccess(false);
        }, 1500);
      } catch (error) {
        console.error(error);
  
        // ✅ backend error message (if thrown)
        alert(
          error?.response?.data?.message ||
            error?.message ||
            "Something went wrong!",
        );
      } finally {
        setLoading(false);
      }
    };
  return (
    <>
      <div className={style.interviewContainer}>
        <div className={style.title}>Interview for this Candidate</div>

        {/* ✅ TABLE */}
        {data?.length > 0 ? (
          <div className={style.tableContainer}>
            {/* TABLE */}

            <table className={style.candidateTable}>
              <thead>
                <tr className={style.trWrapper}>
                  <th>Interview ID</th>
                  <th>Job Category</th>
                  <th>Interview Date</th>
                  <th>Scheduled by</th>
                  {/* <th>CTC (in rupees)</th> */}
                  {hasJoinedCtc && <th>CTC (in rupees)</th>}
                  <th>Status</th>
                </tr>
              </thead>

              <tbody className={style.tableBody}>
                {data.map((doc) => {
                  const subStageLabel = doc.current_sub_stage_name || "";
                  const subBadge = getSubStageBadge(subStageLabel);
                  const cleanedStage = doc.current_stage_name?.replace(
                    /Interview\s*/i,
                    "",
                  );
                  const mainBadge = getMainStageBadge(cleanedStage);
                  // const isJoined = data?.some?.(doc => Number(doc.current_stage_id) === 27) || false;
                  const isJoined = Number(doc.current_stage_id) === 27;

                  return (
                    <tr key={doc.id}>
                      {/* ID */}
                      <td>{doc.id}</td>

                      {/* JOB CATEGORY */}
                      <td>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>
                            <b>{doc.job_category}</b>
                          </span>
                          <span style={{ fontSize: "12px", color: "#666" }}>
                            {doc.Job_company_name}
                          </span>
                        </div>
                      </td>

                      {/* DATE */}
                      <td>{dateFormateDD(doc.interview_date)}</td>

                      {/* ADMIN */}
                      <td>
                        <div className="d-flex align-items-center">
                          <span className={style.assignedTo}>
                            <span className={style.assignedToFirstLetter}>
                              {doc.user_name?.charAt(0)?.toUpperCase() || "?"}
                            </span>
                            <span className="me-1">
                              {doc.user_name || "Unknown"}
                            </span>
                          </span>
                        </div>
                      </td>

                      {/* CTC (in rupees) - ADD CLICK HANDLER */}
                      {hasJoinedCtc && (
                        <td>
                          <div className="d-flex align-items-center">
                            <BsPencilSquare
                              className={`text-success me-2 fs-5 ${!isJoined ? 'opacity-50' : ''}`}
                              style={{
                                cursor: isJoined ? "pointer" : "not-allowed",
                                opacity: !isJoined ? 0.5 : 1
                              }}
                              onClick={() => {
                                if (isJoined) {
                                  setjoinedId(doc.id);
                                  setShowCtctEdit(true);
                                  setInterviewStatus(prev => ({ ...prev, ctc: doc.ctc || "" }));
                                }
                              }}
                            />
                            {doc.ctc ? `₹${Number(doc.ctc).toLocaleString('en-IN')}` : '-'}
                          </div>
                        </td>
                      )}


                      {/* STAGE */}
                      <td>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {/* Badge */}
                          <span
                            style={{
                              backgroundColor: subStageLabel
                                ? subBadge.bg
                                : mainBadge?.bg || "#eeeeee",
                              color: subStageLabel
                                ? subBadge.color
                                : mainBadge?.color || "#333",
                              padding: "4px 8px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            {subStageLabel
                              ? `${cleanedStage} - ${subBadge.label}`
                              : mainBadge?.label || "No Stage"}
                          </span>

                          {/* Three dots */}
                          {(isSuperAdmin || isTeamLeader) && (
                            <div style={{ position: "relative" }}>
                              <BsThreeDotsVertical
                                onClick={(e) =>
                                  handleMenuClick(e, doc.id, doc.admin_id , doc)
                                } // ✅ pass admin_id
                                style={{ cursor: "pointer" }}
                              />

                              <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                              >
                                <div
                                  style={{ padding: "10px", minWidth: "180px" }}
                                >
                                  <MenuItem
                                    onClick={() => {
                                      handleClose();
                                      setAssignOpen(true);
                                      fetchAdmins();
                                    }}
                                  >
                                    Assign To
                                  </MenuItem>

                                    <MenuItem
                                      onClick={() => {
                                        handleClose();
                                        
                                        setOpenModal(true); // ✅ MUST ADD
                                        // console.log(doc,"ssss")
                                      }}
                                    >
                                      Reschedule
                                    </MenuItem>
                                   
                                </div>
                              </Popover>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={style.activitiesBodyContainer}>
            <h6>
              <b>No Interviews</b>
            </h6>
          </div>
        )}
      </div>
      {assignOpen && (
        <MyModal>
          <ModalContainer>
            <div>
              <div className="d-flex justify-content-between">
                <b>Assign To</b>
                <button
                  onClick={() => setAssignOpen(false)}
                  className={style.cancelButton}
                >
                  <AiOutlineClose />
                </button>
              </div>

              <div className="mt-3">
                <Autocomplete
                  options={adminList || []}
                  getOptionLabel={(opt) => opt?.user_name || ""}
                  value={selectedAdmin}
                  onChange={handleAdminChange}
                  getOptionDisabled={(option) =>
                    option.admin_id === currentAdminId
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Admin" />
                  )}
                />
              </div>

              <div className="mt-3 text-end">
                <button
                  onClick={handleAssign}
                  disabled={loading}
                  className={style.primaryButton}
                >
                  {loading ? "Assigning..." : "Assign"}
                </button>
              </div>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {showCtcEdit && (
        <MyModal>
          <ModalContainer>
            <div style={{
              // width: "400px",
              // padding: "20px",
              backgroundColor: "white",
              borderRadius: "8px"
            }}>
              <form onSubmit={submitCtc}>
                <div className="text-center mb-3">
                  <b>Update CTC</b>
                </div>
                <div className="mb-3">
                  <label htmlFor="ctc" className="mb-1">
                    <b>Enter CTC : </b>
                  </label>
                  <input
                    type="text"
                    id="ctc"
                    name="ctc"
                    className="form-control"
                    onChange={(e) =>
                      setInterviewStatus((prev) => ({
                        ...prev,
                        ctc: e.target.value,
                      }))
                    }
                    value={interviewStatus.ctc}
                    maxLength={7}
                    required
                    pattern="\d+"
                    title="Please enter a valid CTC (numbers only)."
                  />
                </div>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCtctEdit(false);
                    }}
                    className="btn btn-danger"
                  >
                    No
                  </button>
                  <button type="submit" className="btn btn-success">
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {openSuccess && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully Changed!"} />
          </ModalContainer>
        </MyModal>
      )}
      {showSuccess && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully Updated"} />
          </ModalContainer>
        </MyModal>
      )}
      {openModal && (
              <MyModal>
                <ModalContainer onClose={() => setOpenModal(false)}>
                  <div style={{width:"500px"}}>
                    <div className="text-center">
                    <b>Reschedule</b>
                  </div>
                  <br />
                  <div>Company Name : <b>{selectedCandidate.company_name}</b></div>
                  <br />
                         
                    <TextField
                      fullWidth
                      type="date"
                      name="eventDate"
                      value={status.eventDate}
                      onChange={handleChange}
                      error={!!errors.eventDate}
                      helperText={errors.eventDate}
                      inputProps={{
                        min: today}
                      }
                    />
    
      
                  <TextField
                    fullWidth
                    name="notes"
                    label="Notes"
                    className="mt-3"
                    value={status.notes}
                    onChange={handleChange}
                  />
      
                  <div className="d-flex justify-content-end gap-2 mt-2">
                    <button
                      onClick={() => {setOpenModal(false); setSelectedCandidate("")}}
                      className={styles.cancelButton}
                    >
                      No
                    </button>
      
                    <button
                      onClick={handleSubmit}
                      disabled={loading}
                      className={styles.SubmitButton}
                    >
                      {loading ? "Saving..." : "Yes"}
                    </button>
                  </div>
                  </div>
                </ModalContainer>
              </MyModal>
            )}
      
            {success && (
              <MyModal>
                <ModalContainer zIndex={1000}>
                  <SuccessTick HeadText="Successfully Moved!" />
                </ModalContainer>
              </MyModal>
            )}
            {showerrMsg && (
        <>
          <MyModal>
            <ModalContainer
              zIndex={1000}
              onClose={() => {
                setShowerrMsg(false);
                setInterviewmessage("");
              }}
            >
              <div>
                {Interviewmessage}

                <div className="d-flex justify-content-end align-items-center ">
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setShowerrMsg(false);
                      setInterviewmessage("");
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </ModalContainer>
          </MyModal>
        </>
      )}
    </>
  );
}

export default Interviews;


